var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardBonds = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0V0z",
    id: "y9ej9en11a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#y9ej9en11a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.32 6.149-.035 49.116a4.413 4.413 0 0 0 3.778 4.365l36.366 5.337-3.15-4.628v-46.9a3.399 3.399 0 0 0-3.014-3.373L14.321 6.15z",
    fill: "#C9DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.995 61.416-6.935-1.141V13.52a3.636 3.636 0 0 1-.033-.398 5.64 5.64 0 0 0-.35-.932 5.056 5.056 0 0 0-.53-.888c-.173-.228-.744-.965-1.74-1.395a4.102 4.102 0 0 0-1.17-.308c-1.215-.155-3.008-.415-5.288-.743L14.72 5.013a2.278 2.278 0 0 0-.539.007c-.142.02-.378.065-1.02.382-.455.224-.681.337-.924.52a3.159 3.159 0 0 0-.676.655c-.381.51-.487 1-.51 1.12-.059.298-.056.55-.041.725l33.565 4.858a2.756 2.756 0 0 1-.027-.388c0-.205.006-.762.336-1.34.265-.465.61-.72.818-.868a3.088 3.088 0 0 1 2.497-.52c.535.119.884.35 1.227.578.436.288.875.58 1.198 1.129.21.357.312.722.438 1.171.08.283.13.524.16.695l.087 46.792a3.852 3.852 0 0 0-.018.508c.002.068.017.473.146.924.245.856.78 1.46.952 1.65.224.248.62.678 1.28.996a3.87 3.87 0 0 0 2.489.308c.279-.061 1.432-.345 2.195-1.395.145-.2.58-.815.64-1.686.013-.17.008-.314 0-.417h.003z",
    fill: "#3A768E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "M22.277 16.08v3.69l21.925 3.099v-3.837zM18.243 23.386v1.567l29.074 4.008v-1.61zM18.021 29.57v1.566l29.074 4.008v-1.61zM18.09 35.936v1.566l29.073 4.009V39.9zM17.87 41.968v1.567l29.073 4.007v-1.609zM17.706 47.495v1.43l16.255 2.278V49.72z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardBonds);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-bonds.91f0a149f1877881c3469e8a04c8298a.svg";